<template>
  <el-form class="form" ref="form" label-position="top">
    <el-form-item label="Application" :gutter="10">
      <template slot="label">
        <span class="is-size-6">Application</span>
        <span class="is-size-7">
          showing  {{showing}}/{{ featuresTableData.length }}
        </span>
      </template>
      <el-row :gutter="10">
        <el-col :xs="22" :sm="20">
          <el-select
            style="width: 100%;"
            v-model="selectedApps"
            multiple
            filterable
            placeholder="Any"
            @change="handleChange"
          >
            <el-option
              v-for="app in featuresTableData"
              :key="app.appCode"
              :label="app.label "
              :value="app.appCode">
            </el-option>
          </el-select>
        </el-col>
        <el-col :xs="22" :sm="2">
          <el-button type="danger" v-show="canClear" @click="handleClear">clear</el-button>
        </el-col>
      </el-row>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ApplicationFilter',
  data () {
    return {
      selectedApps: []
    }
  },
  computed: {
    showing () {
      return this.selectedApps.length || this.featuresTableData.length
    },
    canClear () {
      return this.selectedApps.length > 0
    },
    ...mapGetters(['featuresTableData'])
  },
  watch: {
    featuresTableData: {
      immediate: true,
      deep: true,
      handler (nV) {
        this.handleChange()
      }
    }
  },
  methods: {
    handleChange () {
      let apps = this.selectedApps.length ? this.featuresTableData.filter((item) => this.selectedApps.indexOf(item.appCode) !== -1) : [...this.featuresTableData]
      this.$emit('change', apps)
    },
    handleClear () {
      this.selectedApps = []
      this.handleChange()
    }
  }

}
</script>

<style lang="scss" scoped>
  .form ::v-deep .el-form-item__label {
    margin-bottom: 0;
    line-height: 1;
  }
</style>
